import classes from './pozitivnaProgresija.module.css'
import classesK from '../kalkulatori.module.css'
import { useState } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import ResultsSection from '../redesign/components/ResultsSection'
import add from '../images/add.svg'
import runCalculator from '../api/runCalculator'

const PozitivnaProgresija = () => {
  const [showInputArea, setShowInputArea] = useState(true)
  const [loading, setLoading] = useState(false)
  const [apiError, setApiError] = useState('')
  const [data, setData] = useState({
    values: {
      serie1: {
        odd: [''],
        percent: [''],
      },
      stake: [''],
    },
    results: {
      serie1Results: ['-', '-', '-', '-'],
    },
  })

  const clearFields = () => {
    setData({
      values: {
        serie1: {
          odd: [''],
          percent: [''],
        },
        stake: [''],
      },
      results: {
        serie1Results: ['-', '-', '-', '-'],
      },
    })
    setShowInputArea(true)
    setSeries([{ id: 1 }])
    setApiError('')
  }

  const [series, setSeries] = useState([{ id: 1 }])

  const addSeries = () => {
    setSeries((prevSeries) => {
      const newSeries = [...prevSeries, { id: prevSeries.length + 1 }]
      setData((prevData) => {
        const newSerieKey = `serie${newSeries.length}`
        return {
          ...prevData,
          values: {
            ...prevData.values,
            [newSerieKey]: {
              odd: [0],
              percent: [0],
            },
          },
          results: {
            ...prevData.results,
            [`${newSerieKey}Results`]: prevData.results[
              `${newSerieKey}Results`
            ] || ['-', '-', '-', '-'],
          },
        }
      })
      return newSeries
    })
  }

  const buildBody = () => {
    const oddsList = series.map(
      (serie) => parseFloat(data.values[`serie${serie.id}`]?.odd[0]) || 0
    )
    const carryForwardPercentages = series.map(
      (serie) => parseFloat(data.values[`serie${serie.id}`]?.percent[0]) || 0
    )

    return {
      initialStake: parseFloat(data.values.stake[0]) || 0,
      oddsList,
      carryForwardPercentages,
    }
  }

  const handleCalculateAll = async () => {
    setLoading(true)
    setApiError('')

    try {
      const result = await runCalculator(
        'progressions',
        'positive-progression',
        buildBody()
      )

      const rows = result.rows || []

      setData((prevData) => {
        const updatedData = { ...prevData }

        series.forEach((serie, index) => {
          const serieKey = `serie${serie.id}`
          const row = rows[index]

          updatedData.results[`${serieKey}Results`] = row
            ? [
                Number(row.potentialWin).toFixed(2),
                Number(row.netProfit).toFixed(2),
                Number(row.carryForwardUnits).toFixed(2),
                Number(row.currentBalance).toFixed(2),
              ]
            : ['-', '-', '-', '-']
        })

        return updatedData
      })
    } catch (err) {
      setApiError('Greška pri obračunu, pokušajte ponovo.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={classesK.container}>
      <InfoBar
        calculatorType={`Pozitivna progresija`}
        onRefresh={clearFields}
      />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Obračunaj rezultate</span>
          <button onClick={handleCalculateAll} disabled={loading}>
            {loading ? 'Obračun u toku...' : 'Prikaži rezultate'}
          </button>
        </div>
        {apiError && <div className={classesK.errorMessage}>{apiError}</div>}
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>Igra</div>
              {series.map((serie) => (
                <div key={serie.id} className={classes.seriesContainer}>
                  <div
                    className={`${classesK.calcButton} ${classes.calcButton}`}
                  >
                    Serija br. {serie.id}
                  </div>
                  <div className={classes.seriesValues}>
                    <div className={classes.oddsContainer}>
                      {serie.id === 1 && (
                        <div className={classesK.oddsContainer}>
                          <span>Upiši ulog</span>
                          <input
                            type='number'
                            min='0'
                            value={data.values.stake[0]}
                            onChange={(e) => {
                              const value = parseFloat(e.target.value)

                              setData((prevData) => ({
                                ...prevData,
                                values: {
                                  ...prevData.values,
                                  stake: [value],
                                },
                              }))
                            }}
                          />
                        </div>
                      )}
                      <div className={classesK.oddsContainer}>
                        <span>Upiši kvotu</span>
                        <input
                          type='number'
                          min='0'
                          value={data?.values[`serie${serie.id}`]?.odd[0] || ''}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value)

                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                [`serie${serie.id}`]: {
                                  ...prevData.values[`serie${serie.id}`],
                                  odd: [value],
                                },
                              },
                            }))
                          }}
                        />
                      </div>
                    </div>
                    <ResultsSection
                      names={['Eventualni dobitak', 'Čista dobit']}
                      results={[
                        data?.results[`serie${serie.id}Results`]
                          ? data.results[`serie${serie.id}Results`][0] || '-'
                          : '-',
                        data?.results[`serie${serie.id}Results`]
                          ? data.results[`serie${serie.id}Results`][1] || '-'
                          : '-',
                      ]}
                      allowNegative={true}
                    />
                    <div className={classesK.oddsContainer}>
                      <span>
                        Upiši samo br. procenta prenosa u sl. krug ( % )
                      </span>
                      <input
                        type='number'
                        min='0'
                        value={
                          data?.values[`serie${serie.id}`]?.percent[0] || ''
                        }
                        onChange={(e) => {
                          const value = parseFloat(e.target.value)

                          setData((prevData) => ({
                            ...prevData,
                            values: {
                              ...prevData.values,
                              [`serie${serie.id}`]: {
                                ...prevData.values[`serie${serie.id}`],
                                percent: [value],
                              },
                            },
                          }))
                        }}
                      />
                    </div>

                    <ResultsSection
                      names={['Prenos u valuti', 'Trenutno stanje']}
                      results={[
                        data?.results[`serie${serie.id}Results`]
                          ? data.results[`serie${serie.id}Results`][2]
                          : '-',
                        data?.results[`serie${serie.id}Results`]
                          ? data.results[`serie${serie.id}Results`][3]
                          : '-',
                      ]}
                      allowNegative={true}
                    />
                  </div>
                </div>
              ))}
              {series.length < 25 && (
                <div className={classesK.addMore}>
                  <button onClick={addSeries} className={classesK.addButton}>
                    <img src={add} height={18} width={18} alt='image' />
                    Dodaj još jednu seriju
                  </button>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default PozitivnaProgresija
